import React, { useCallback, useEffect, useState } from 'react';
import ScanAddCameraComponent from './ScanAddCamera';
import './index.scss';
import RTMPlinkAddCamera from './RTMPlinkAddCamera';
import { Tabs } from 'antd';
import queryString from 'query-string';
import * as SERVICE from '../../../constants/service.types';
import { socketEmitEvent } from '../../../redux/actions';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import RTSPlinkAddCameraComponent from './RTSPlinkAddCamera';
import MilestoneCameraAddComponent from './MilestoneCameraAdd';
import AddBodyCameraComponent from './BodyCamera';

const { TabPane } = Tabs;

const AddCameraComponent = ({ onDone, gatewaySerial, gatewayAddress, factorySerial, gatewayLocalAddress }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const {
    isAuth,
    cameras: pageCameras,
    updateDevice,
    namespace,
    addDeviceData,
    checkExternalDevice,
    activeDeviceData,
  } = useSelector((state) => state);

  const [page] = useState(1);
  const [pageSize] = useState(10);
  const [cameras, setCameras] = useState();
  const [total, setTotal] = useState(0);
  const [requestId] = useState(new Date().getTime());
  const [setSelectCamera] = useState();
  const [visibleEdit, setVisibleEdit] = useState();

  const [visibleAddCamera, setVisibleAddCamera] = useState(false);
  const [addDeviceReturn, setAddDeviceReturn] = useState(addDeviceData);
  const [checkExternalDeviceReturn, setCheckExternalDeviceReturn] = useState();
  const [activeDeviceReturn, setActiveDeviceReturn] =
    useState(activeDeviceData);
  const [dataSearchCamera, setDataSearchCamera] = useState();
  const [key, setKey] = useState(Math.random());
  const [nameCameraSearch, setNameCameraSearch] = useState();
  const [keyTab, setKeyTab] = useState('1');
  const [updateReturn, setUpdateReturn] = useState();

  useEffect(() => {
    return () => {
      setAddDeviceReturn(null);
      setCheckExternalDeviceReturn(null);
      setActiveDeviceReturn(null);
    };
  }, []);

  useEffect(() => {
    if (pageCameras) {
      setCameras(pageCameras.data);
      setTotal(pageCameras.totalSize);
      if (pageCameras.data?.length === 1) {
        setSelectCamera(pageCameras.data?.[0]);
      }
    }
  }, [pageCameras, setSelectCamera]);

  const getDeviceByPage = useCallback(
    (page, size, dataSearch, serial) => {
      let data = {
        namespace,
        deviceType: 'camera',
        timeRequest: requestId,
        page,
        size,
        factorySerial: serial,
      };
      if (dataSearch) {
        data.name = dataSearch;
      }
      let dataObj = {
        appServiceType: SERVICE.LIST_ALL_DEVICE_BY_PAGE,
        requestId,
        body: JSON.stringify(data),
      };
      return dispatch(socketEmitEvent(dataObj));
    },
    [dispatch, namespace, requestId]
  );

  useEffect(() => {
    const { redirect, camera } = queryString.parse(location.search);
    const { key } = queryString.parse(location.hash);
    if (
      redirect &&
      key &&
      cameras &&
      cameras.some((child) => child.serial === key)
    ) {
      history.push('#storage');
      setNameCameraSearch(camera);
      return setSelectCamera(
        cameras && cameras.filter((camera) => camera.serial === key)[0]
      );
    }
  }, [cameras, history, location, setSelectCamera]);

  useEffect(() => {
    if (updateDevice && updateDevice.requestId === requestId) {
      setUpdateReturn(updateDevice);
      if (page && isAuth === 1 && pageSize && namespace) {
        getDeviceByPage(page - 1, pageSize);
      }
    }
  }, [getDeviceByPage, isAuth, namespace, page, pageSize, requestId, updateDevice]);
  useEffect(() => {
    if (
      visibleEdit &&
      updateReturn &&
      updateReturn.serial === visibleEdit.serial
    ) {
      if (updateReturn.isSuccess) {
        setCameras((state) =>
          state.map((camera) => {
            if (camera.serial !== updateReturn.data.serial) return camera;
            return { ...camera, ...updateReturn.data };
          })
        );
        setUpdateReturn(null);
        setVisibleEdit(null);
      }
    }
  }, [updateReturn, visibleEdit]);

  useEffect(() => {
    setAddDeviceReturn(addDeviceData);
  }, [addDeviceData]);

  useEffect(() => {
    setCheckExternalDeviceReturn(checkExternalDevice);
  }, [checkExternalDevice]);

  useEffect(() => {
    setActiveDeviceReturn(activeDeviceData);
  }, [activeDeviceData]);


  const onUpdateCamera = useCallback(
    (data, requestId, gatewaySerial, factorySerial) => {
      if (data) {
        let dataObj = {
          appServiceType: SERVICE.UPDATE_DEVICE,
          requestId,
          body: JSON.stringify({
            ...data,
            namespace,
            gatewaySerial,
            factorySerial,
          }),
        };

        return dispatch(socketEmitEvent(dataObj));
      }
    },
    [dispatch, namespace]
  );

  useEffect(() => {
    if (page && isAuth === 1 && pageSize && namespace) {
      getDeviceByPage(page - 1, pageSize, dataSearchCamera);
    }
  }, [dataSearchCamera, getDeviceByPage, isAuth, namespace, page, pageSize]);


  const onCheckExternalDevice = useCallback(
    (serial) => {
      if (serial && serial.length > 0) {
        let data = {
          serial: serial.trim(),
          namespace,
          deviceType: 'camera',
          extraInfo: {
            factorySerial: serial,
          },
          gatewaySerial,
        };
        let dataObj = {
          appServiceType: SERVICE.CHECK_EXTERNAL_DEVICE,
          requestId: new Date().getTime(),
          body: JSON.stringify(data),
        };
        return dispatch(socketEmitEvent(dataObj));
      }
    },
    [dispatch, namespace, gatewaySerial]
  );


  const onAddCamera = useCallback(
    (serial, name, deviceSerial, typeCamera) => {
      if (serial && serial.length > 0 && name && name.length > 0) {
        let data = {
          namespace,
          serial: deviceSerial,
          deviceType: 'camera',
          extraInfo: {
            typeCamera: typeCamera,
            name: name.trim(),
            factorySerial: serial,
            gatewaySerial,
          },
          factorySerial,
        };

        let dataObj = {
          appServiceType: SERVICE.REQUEST_ADD_EXTERNAL_DEVICE,
          requestId: new Date().getTime(),
          body: JSON.stringify(data),
        };
        return dispatch(socketEmitEvent(dataObj));
      }
    },
    [dispatch, namespace, gatewaySerial, factorySerial]
  );
  return (
    <div className="add-camera-component">
      <Tabs defaultActiveKey="1">
        <TabPane tab={t('Auto Scan Mode')} key="1">
          <ScanAddCameraComponent
            onDone={onDone}
            gatewaySerial={gatewaySerial}
            gatewayAddress={gatewayAddress}
          />
        </TabPane>
        <TabPane tab={t('RTSP Link Mode')} key="2">
          <RTSPlinkAddCameraComponent
            onDone={onDone}
            gatewaySerial={gatewaySerial}
            gatewayAddress={gatewayAddress}
          />
        </TabPane>
        <TabPane tab={t('RTMP Camera')} key="3">
          <RTMPlinkAddCamera
            typeCamera="rtmp_camera"
            dispatch={dispatch}
            checkDeviceReturn={checkExternalDeviceReturn}
            activeDeviceReturn={activeDeviceReturn}
            onCheckExternalDevice={onCheckExternalDevice}
            onAddCamera={onAddCamera}
            onUpdate={onUpdateCamera}
            handleAddSuccessful={(serial) => {
              setVisibleAddCamera(false);
              setKey(Math.random());
              setKeyTab('1');
              getDeviceByPage(page - 1, pageSize, undefined, serial);
              setNameCameraSearch(serial);
              if (onDone) onDone();
            }}
            factorySerial={factorySerial}
            onClose={() => setVisibleAddCamera(false)}
          />
        </TabPane>
        <TabPane tab={t('Milestone Camera')} key="4">
          <MilestoneCameraAddComponent
            onDone={onDone}
            gatewaySerial={gatewaySerial}
            gatewayAddress={gatewayAddress}
          />
        </TabPane>
        <TabPane tab={t('Body Camera')} key="5">
          <AddBodyCameraComponent
            onDone={onDone}
            gatewaySerial={gatewaySerial}
            gatewayLocalAddress={gatewayLocalAddress}
          />
        </TabPane>

      </Tabs>
    </div>
  );
};

export default AddCameraComponent;
